import { Route } from '@angular/router';
import { ALL_ACTIVITY_CATEGORY_SLUGS } from '@cnt-workspace/data-access';

/**
 * Builds the 24×3 sibling view routes for activity-location (POI) detail
 * pages — one `:location/:name/:id` / `:name/:id` / `:id` triple per
 * category slug, matching the pattern already hand-written for
 * `rv-camping`/`boondocking` in `app.routes.ts`. Generated rather than
 * hand-written to keep the 72-entry table out of the otherwise all-literal
 * route file. Each entry still lazy-loads via a relative dynamic import
 * (a real chunk-split point, same as every other route in the app) rather
 * than a static import, so calling this function to build the array doesn't
 * itself pull `ActivityDetailsComponent` into the eagerly-loaded bundle.
 */
export function buildActivityCategoryRoutes(): Route[] {
  return ALL_ACTIVITY_CATEGORY_SLUGS.flatMap((slug) => [
    {
      path: `${slug}/:location/:name/:id`,
      loadComponent: () => import('./activity-details/activity-details.component').then((m) => m.ActivityDetailsComponent),
      data: { categorySlug: slug },
    },
    {
      path: `${slug}/:name/:id`,
      loadComponent: () => import('./activity-details/activity-details.component').then((m) => m.ActivityDetailsComponent),
      data: { categorySlug: slug },
    },
    {
      path: `${slug}/:id`,
      loadComponent: () => import('./activity-details/activity-details.component').then((m) => m.ActivityDetailsComponent),
      data: { categorySlug: slug },
    },
  ]);
}
